var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "box" }, [
    _c("h1", { staticClass: "title is-5" }, [
      _vm._v("Subunidades del documento"),
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "columns is-multiline" },
      _vm._l(_vm.subdocumentos, function (subdoc) {
        return _c(
          "div",
          { key: `doc-${subdoc.key}`, staticClass: "column is-6 is-4-desktop" },
          [
            _c(
              "div",
              { staticClass: "box p-3 is-flex is-flex-direction-row" },
              [
                _c("div", { staticClass: "mr-4" }, [
                  _c("i", {
                    staticClass: "far fa-2x has-text-primary",
                    class: {
                      "fa-copy": subdoc.multiple,
                      "fa-file": !subdoc.multiple,
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "is-flex-grow-1" }, [
                  _c("h4", { staticClass: "title is-6" }, [
                    _vm._v(_vm._s(subdoc.nombre)),
                  ]),
                  _vm._v(" "),
                  _c("h4", { staticClass: "subtitle is-7 mb-3" }, [
                    _vm._v(_vm._s(subdoc.key)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "is-size-7" }, [
                    _c("p", [
                      _c("b", [_vm._v("Formatos")]),
                      _vm._v(
                        ": " + _vm._s(subdoc.formatosSeleccionados.join(", "))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("b", [_vm._v("¿Colección?")]),
                      _vm._v(" \n               "),
                      _c("i", {
                        staticClass: "fas",
                        class: {
                          "fa-check": subdoc.multiple,
                          "fa-times": !subdoc.multiple,
                        },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(subdoc.multiple ? "Si" : "No") +
                          "\n              "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ml-4" }, [
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "has-text-primary",
                        on: {
                          click: function ($event) {
                            return _vm.openConfirmEditSubunidad(subdoc)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-edit" })]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c(
                      "a",
                      {
                        staticClass: "has-text-primary",
                        on: {
                          click: function ($event) {
                            return _vm.openConfirmDeleteSubunidad(subdoc)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-times-circle" })]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("h1", { staticClass: "subtitle is-5" }, [_vm._v("Nueva subunidad")]),
    _vm._v(" "),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Nombre y clave")]),
      _vm._v(" "),
      _c("div", { staticClass: "field is-grouped" }, [
        _c("div", { staticClass: "control is-expanded" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.input.subdocumento.nombre,
                expression: "input.subdocumento.nombre",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true },
                expression: "{required:true}",
              },
            ],
            staticClass: "input",
            class: {
              "is-danger": _vm.errors.has("Nombre del sub-documento", "subdoc"),
            },
            attrs: {
              name: "Nombre del sub-documento",
              "data-vv-scope": "subdoc",
            },
            domProps: { value: _vm.input.subdocumento.nombre },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.input.subdocumento, "nombre", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "help" }, [
            _vm._v("El nombre con el cual identificará la subunidad"),
          ]),
          _vm._v(" "),
          _vm.errors.has("Nombre del sub-documento", "subdoc")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(
                  _vm._s(_vm.errors.first("Nombre del sub-documento", "subdoc"))
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "control is-expanded" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.input.subdocumento.key,
                expression: "input.subdocumento.key",
              },
              {
                name: "validate",
                rawName: "v-validate",
                value: {
                  required: true,
                  regex: /^[a-z0-9]+(?:[-_+][a-z0-9#]+)*$/,
                },
                expression:
                  "{ required: true, regex: /^[a-z0-9]+(?:[-_+][a-z0-9#]+)*$/ }",
              },
            ],
            staticClass: "input is-mono",
            class: {
              "is-danger": _vm.errors.has("Clave del sub-documento", "subdoc"),
            },
            attrs: {
              name: "Clave del sub-documento",
              "data-vv-scope": "subdoc",
            },
            domProps: { value: _vm.input.subdocumento.key },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.input.subdocumento, "key", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "help" }, [_vm._v("Clave (autogenerada)")]),
          _vm._v(" "),
          _vm.errors.has("Clave del sub-documento", "subdoc")
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v(
                  _vm._s(_vm.errors.first("Clave del sub-documento", "subdoc"))
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "columns is-centrered" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Formatos aceptables"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "block" },
              _vm._l(_vm.formatosDisponibles, function (formato) {
                return _c(
                  "b-checkbox",
                  {
                    key: formato,
                    attrs: { "native-value": formato, disabled: "" },
                    model: {
                      value: _vm.input.subdocumento.formatosSeleccionados,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.input.subdocumento,
                          "formatosSeleccionados",
                          $$v
                        )
                      },
                      expression: "input.subdocumento.formatosSeleccionados",
                    },
                  },
                  [_vm._v(_vm._s(formato))]
                )
              }),
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("¿Es colección de documentos?"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "block" },
              [
                _c(
                  "b-radio",
                  {
                    attrs: { "native-value": true },
                    model: {
                      value: _vm.input.subdocumento.multiple,
                      callback: function ($$v) {
                        _vm.$set(_vm.input.subdocumento, "multiple", $$v)
                      },
                      expression: "input.subdocumento.multiple",
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-check" }),
                    _vm._v(" Si\n                "),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-radio",
                  {
                    attrs: { "native-value": false },
                    model: {
                      value: _vm.input.subdocumento.multiple,
                      callback: function ($$v) {
                        _vm.$set(_vm.input.subdocumento, "multiple", $$v)
                      },
                      expression: "input.subdocumento.multiple",
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-times" }),
                    _vm._v(" No\n                "),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column is-narrow" }, [
          _c(
            "button",
            {
              staticClass: "button is-primary",
              on: { click: _vm.submitSubunidad },
            },
            [
              _c("i", { staticClass: "fas fa-plus" }),
              _vm._v(" Agregar\n              "),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v("Puede editar el nombre de las subunidades haciendo clic en "),
        _c("span", { staticClass: "has-text-primary" }, [
          _c("i", { staticClass: "fas fa-edit" }),
        ]),
        _vm._v(", o eliminarlas haciendo clic sobre "),
        _c("span", { staticClass: "has-text-primary" }, [
          _c("i", { staticClass: "fas fa-times-circle" }),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _c("b", [_vm._v("NOTA:")]),
        _vm._v(
          " Solo puede eliminar una subunidad mientras no esté afectada por la ejecución de un evento."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }